import { App, ConfigProvider } from 'antd';
import ReactDOM from 'react-dom/client';
import 'styles/global.css';
import Apps from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider
    prefixCls="okvip"
    iconPrefixCls=""
    theme={{
      token: {
        colorPrimary: '#26a9e0',
        colorInfo: '#26a9e0',
        borderRadius: 4
      },
      components: {
        Button: {
          colorPrimary: '#26a9e0'
        },
        Layout: {
          headerHeight: 20
        }
      }
    }}
  >
    <App
      notification={{
        placement: 'topRight'
      }}
    >
      <Apps />
    </App>
  </ConfigProvider>
);
